export default function(axios) {
    return {
        pullPermissions ({commit}) {
            axios.get('/api/v1/permissions',
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then((response) => {
                commit('setPermissions', response.data);
            }).catch((err) => {
                console.error(err);
            });
        },
        pullAnnouncements ({commit}) {
            axios.get('/api/v1/announcements',
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then((response) => {
                commit('setAnnouncements', response.data);
            }).catch((err) => {
                console.error(err);
            });
        },
        pullInventory ({commit}) {
            axios.get('/api/v1/inventory/types',
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then((response) => {
                commit('setInventoryTypes', response.data);
            }).catch((err) => {
                console.error(err);
            });
            axios.get('/api/v1/inventory/items',
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then((response) => {
                commit('setInventory', response.data);
            }).catch((err) => {
                console.error(err);
            });
            axios.get('/api/v1/inventory/items',
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then((response) => {
                commit('setInventory', response.data);
            }).catch((err) => {
                console.error(err);
            });
        },
        pullRanks ({commit}) {
            axios.get('/api/v1/ranks',
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then((response) => {
                commit('setRanks', response.data);
            }).catch((err) => {
                console.error(err);
            });
        },
        pullTerms ({commit}) {
            axios.get('/api/v1/terms',
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then((response) => {
                commit('setTerms', response.data.sort((a, b) => { return b.term - a.term; }));
            }).catch((err) => {
                console.error(err);
            });
        },
        pullObjectives ({commit}) {
            axios.get('/api/v1/objectives',
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then((response) => {
                response.data.forEach((obj) => {
                    obj.editing = false;
                    obj.del_visible = false;
                });
                commit('setObjectives', response.data);
            }).catch((err) => {
                console.error(err);
            });
        },
        pullLevels ({commit}) {
            axios.get('/api/v1/level',
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then((response) => {
                commit('setLevels', response.data);
            }).catch((err) => {
                console.error(err);
            });
        },
        pullEventTypes ({commit}) {
            axios.get('/api/v1/eventtypes',
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then((response) => {
                commit('setEventTypes', response.data);
            }).catch((err) => {
                console.error(err);
            });
        },
        pullAttendanceTypes ({commit}) {
            axios.get('/api/v1/attendancetypes',
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then((response) => {
                commit('setAttendanceTypes', response.data);
            }).catch((err) => {
                console.error(err);
            });
        },
        pullAttendance ({commit}) {
            axios.get('/api/v1/attendance',
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then((response) => {
                commit('setAttendance', response.data);
            }).catch((err) => {
                console.error(err);
            });
        },
        pullEvents ({commit}) {
            axios.get('/api/v1/events',
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then((response) => {
                commit('setEvents', response.data.sort((a, b) => {
                    return new Date(a.date) - new Date(b.date);
                }));
            }).catch((err) => {
                console.error(err);
            });
        },
        pullSelfUpdates ({commit}, url) {
            axios.get(url,
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then((response) => {
                commit('setSelfUpdates', response.data);
            }).catch((err) => {
                console.error(err);
            });
        },
        pullAdminUpdates ({commit}, url) {
            axios.get(url,
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then((response) => {
                commit('setAdminUpdates', response.data);
            }).catch((err) => {
                console.error(err);
            });
        },
        pullApprovalUpdates ({commit}, url) {
            axios.get(url,
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then((response) => {
                commit('setApprovalUpdates', response.data);
            }).catch((err) => {
                console.error(err);
            });
        },
        pullPublishedUpdates ({commit}, url) {
            axios.get(url,
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then((response) => {
                commit('setPublishedUpdates', response.data);
            }).catch((err) => {
                console.error(err);
            });
        },
        pullDistributionList ({commit}) {
            axios.get('/api/v1/distributionlists',
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then((response) => {
                commit('setDistributionList', response.data);
            }).catch((err) => {
                console.error(err);
            });
        },
        pullDisputeTypes ({commit}) {
            axios.get('/api/v1/attendance/disputes/types',
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then((response) => {
                commit('setDisputeTypes', response.data);
            }).catch((err) => {
                console.error(err);
            });
        },
        pullSelfDisputes ({commit}) {
            axios.get('/api/v1/attendance/disputes',
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then((response) => {
                commit('setSelfDisputes', response.data);
            }).catch((err) => {
                console.error(err);
            });
            axios.get('/api/v1/attendance/disputable',
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then((response) => {
                commit('setDisputable', response.data);
            }).catch((err) => {
                console.error(err);
            });
        },
        pullPositions ({commit}) {
            axios.get('/api/v1/positions/flat',
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then((response) => {
                response.data.forEach((position) => {
                    position.editing = false;
                    position.del_visible = false;
                });
                commit('setPositions', response.data);
            }).catch((err) => {
                console.error(err);
            });
        },
        pullUnits ({commit}) {
            axios.get('/api/v1/units',
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then((response) => {
                response.data.forEach((unit) => {
                    unit.editing = false;
                    unit.del_visible = false;
                });
                commit('setUnits', response.data);
            }).catch((err) => {
                console.error(err);
            });
        }
    }
}
